<router-outlet />

<bootstrap-modal></bootstrap-modal>
<bg-tooltip 
    *ngFor="let tooltip of tooltipService.tooltipsList"
    [title]="tooltip.title"
    [ref]="tooltip.ref"
    [position]="tooltip.position"
    [color]="tooltip.color"
    [width]="tooltip.width"
    [tooltipHeaderTitle]="tooltip.tooltipHeaderTitle"
    [tooltipType]="tooltip.tooltipType">
</bg-tooltip>